<section class="bg-platinum text-white py-16 sm:py-20">
  <div class="mx-auto max-w-5xl px-5">
    <div class="mx-auto max-w-4xl text-center">
      <h2 class="text-3xl font-bold tracking-tight sm:text-4xl">
        The benefits of <span class="text-turquoise">AI sports betting</span>
      </h2>
      <p class="mt-4 text-lg leading-8 text-gray-300">
        Whether you’re new to betting or a seasoned bettor, here’s why AI football prediction tools like Dimers Platinum are changing the game:
      </p>
    </div>

    <div class="mx-auto mt-12 max-w-5xl space-y-4">
      
      <div *ngFor="let benefit of benefits" class="flex flex-col md:flex-row items-center gap-x-4 gap-y-4 rounded-2xl bg-turquoise/10 p-4 ring-1 ring-white/5 transition-all duration-300 ease-in-out 
              hover:scale-[1.02] hover:ring-1 hover:ring-turquoise hover:shadow-2xl hover:shadow-cyan-500/20">
        
        <div class="flex-shrink-0 sm:w-32 sm:h-32 flex items-center justify-center">
            <video  #videoPlay *ngIf="isBrowser" class="bg-white/5 rounded-2xl" autoplay loop muted playsinline>
                <source [src]="benefit.videoUrl"
                    type="video/mp4" />
                Your browser does not support the video tag.
            </video>
             <div *ngIf="!isBrowser" class="w-full h-full bg-gray-900/50 rounded-xl flex items-center justify-center ring-1 ring-white/10">
                <span class="text-sm text-gray-500">Video</span>
            </div>
        </div>

        <div>
          <h3 class="text-xl font-semibold leading-7 text-white">{{ benefit.title }}</h3>
          <p class="mt-2 text-base leading-7 text-gray-300">{{ benefit.description }}</p>
        </div>
      </div>

    </div>
  </div>
</section>